(() => {
  const CONFIG = {
    scope: "global",
    drawerSelector: "kaching-cart-drawer#cart-drawer",
    activeClass: "gruns-cart-variant-active",
    drawerActiveClass: "gruns-cart-variant-drawer",
    // observerDebounceMs: 80,
    observerDebounceMs: 200,
    debug: false,
  };

  const GRUNS_CART_PRODUCT_HANDLES = {
    superTea: "yerba-magic-yerba-mate-instant-tea-powder-peach-mango-flavor",
    sticks: "yerba-magic®-yerba-mate-instant-tea-powder-variety-pack-24-servings",
    capsule30: "yerba-magic-5-in-1-capsules",
    capsule60: "yerba-magic-pure-yerba-mate-capsules-copy",
    whisk: "yerba-magic-frother",
  };

const GRUNS_CART_UPSELL_PRODUCTS = {
  superTea: {
    key: "superTea",
    productHandle: GRUNS_CART_PRODUCT_HANDLES.superTea,
    variantId: 50182305055030,
    title: "Yerba Magic® | Instant 5-in-1 Super Tea - 30 Servings",
    subtitle: "Peach Mango",
    price: "$39.99",
    compareAtPrice: "",
    image: "",
    buttonText: "ADD TO CART",
    copy: {
      oneTime: {
        heading: "The Flavor That Completes Your Yerba Magic Ritual",
        description:
          "Try all the flavors and find your favorite. The Variety Pack gives you 24 servings of clean energy - one sip at a time.",
      },
      subscription: {
        heading: "Complete Your Yerba Magic Ritual",
        description:
          "Add a 30-serving pouch to your routine and keep clean energy ready whenever you need it.",
      },
    },
  },

  sticks: {
    key: "sticks",
    productHandle: GRUNS_CART_PRODUCT_HANDLES.sticks,
    variantId: 53867183800630,
    title: "Yerba Magic® | Variety Pack (24 Servings)",
    subtitle: "24 Servings",
    price: "$39.99",
    compareAtPrice: "",
    image: "",
    buttonText: "ADD TO CART",
    copy: {
      oneTime: {
        heading: "Try Every Flavor of Yerba Magic",
        description:
          "Add the Variety Pack and discover your favorite flavor with 24 servings of clean energy.",
      },
      subscription: {
        heading: "Add More Variety to Your Routine",
        description:
          "Pair your subscription with the Variety Pack so you always have more flavors ready to go.",
      },
    },
  },

  whisk: {
    key: "whisk",
    productHandle: GRUNS_CART_PRODUCT_HANDLES.whisk,
    variantId: 53664733561142,
    title: "Yerba Magic® | Premium Electric Whisk",
    subtitle: "Handheld Frother & Drink Mixer with Stand",
    price: "$19.99",
    compareAtPrice: "",
    image: "",
    buttonText: "ADD TO CART",
    copy: {
      oneTime: {
        heading: "The Frother That Completes Your Yerba Magic Ritual",
        description:
          "Your drink tastes better when you make it right. Add the Frother and make every sip perfect.",
      },
      subscription: {
        heading: "Make Every Subscription Sip Smoother",
        description:
          "Pair your recurring Yerba Magic order with the Frother for smoother drinks every time.",
      },
    },
  },
};

const GRUNS_CART_PRODUCT_IMAGE_CACHE = {};


  const INSTANCE_KEY = "__grunsCartVariant";
  const GRUNS_CART_LAST_UPSELL_HANDLE_KEY = "__grunsCartLastUpsellHandle";

  /**
   * Avoid running more than one instance if VWO evaluates the variation again.
   */
  if (window[INSTANCE_KEY]?.destroy) {
    window[INSTANCE_KEY].destroy();
  }

  let observer = null;
  let debounceTimer = null;

  const log = (...args) => {
    if (CONFIG.debug) {
      console.log("[Gruns Cart Variant]", ...args);
    }
  };

  const isVariantAllowed = () => {
    return CONFIG.scope === "global";
  };

  const getDrawer = () => {
    return document.querySelector(CONFIG.drawerSelector);
  };


/* ==========================================================================
   Scrollable Layout
   ========================================================================== */

const GRUNS_CART_SCROLL_AREA_SELECTOR = "[data-gruns-cart-scroll-area]";
const GRUNS_CART_SCROLLABLE_SUMMARY_SELECTOR =
  "[data-gruns-scrollable-order-summary]";

const getDrawerInner = (drawer) => {
  return drawer.querySelector(".kaching-cart__inner") || drawer;
};

const ensureCartScrollArea = (drawer) => {
  const inner = getDrawerInner(drawer);

  let scrollArea = drawer.querySelector(GRUNS_CART_SCROLL_AREA_SELECTOR);

  if (scrollArea) {
    return scrollArea;
  }

  scrollArea = document.createElement("div");
  scrollArea.className = "gruns-cart-scroll-area";
  scrollArea.dataset.grunsCartScrollArea = "";

  const freeShippingBar = drawer.querySelector(
    "[data-gruns-cart-free-shipping-bar]"
  );
  const header = drawer.querySelector(".kaching-cart__header");
  const footer = drawer.querySelector(".kaching-cart__footer");

  if (freeShippingBar) {
    freeShippingBar.insertAdjacentElement("afterend", scrollArea);
  } else if (header) {
    header.insertAdjacentElement("afterend", scrollArea);
  } else if (footer) {
    footer.insertAdjacentElement("beforebegin", scrollArea);
  } else {
    inner.appendChild(scrollArea);
  }

  return scrollArea;
};

const getScrollableOrderSummary = (drawer) => {
  let summary = drawer.querySelector(GRUNS_CART_SCROLLABLE_SUMMARY_SELECTOR);

  if (summary) {
    return summary;
  }

  summary = document.createElement("div");
  summary.className = "gruns-scrollable-order-summary";
  summary.dataset.grunsScrollableOrderSummary = "";

  return summary;
};

const removeDuplicateScrollableOrderSummaries = (drawer) => {
  const summaries = Array.from(
    drawer.querySelectorAll(GRUNS_CART_SCROLLABLE_SUMMARY_SELECTOR)
  );

  if (summaries.length <= 1) {
    return summaries[0] || null;
  }

  const firstSummary = summaries[0];

  summaries.slice(1).forEach((summary) => {
    summary.remove();
  });

  return firstSummary;
};


const hydrateScrollableCartLayout = (drawer) => {
  const footer = drawer.querySelector(".kaching-cart__footer");
  const contents = drawer.querySelector(".kaching-cart__contents");
  const upsell = drawer.querySelector("[data-gruns-cart-upsell]");
  const summary = removeDuplicateScrollableOrderSummaries(drawer);
  const scrollArea = drawer.querySelector("[data-gruns-cart-scroll-area]");

  if (!contents) {
    return;
  }

  /*
    Important:
    Do NOT move .kaching-cart__contents anymore.
    Kaching native cart controls depend on this node staying in its original flow/context.
  */

  if (scrollArea && contents.parentElement === scrollArea) {
    if (footer) {
      footer.insertAdjacentElement("beforebegin", contents);
    } else {
      drawer.appendChild(contents);
    }

    scrollArea.remove();
  }

  /*
    Only move custom modules when needed.
    Do not call appendChild on every initialization, because that creates
    a MutationObserver loop and can interrupt real click events.
  */

  if (upsell && upsell.parentElement !== contents) {
    contents.appendChild(upsell);
  }

  if (summary && summary.children.length && summary.parentElement !== contents) {
    contents.appendChild(summary);
  }

  /*
    Keep summary after upsell only if both exist and are already inside contents
    but in the wrong order.
  */

  if (
    upsell &&
    summary &&
    upsell.parentElement === contents &&
    summary.parentElement === contents &&
    upsell.compareDocumentPosition(summary) & Node.DOCUMENT_POSITION_PRECEDING
  ) {
    contents.insertBefore(upsell, summary);
  }

  if (footer) {
    footer.dataset.grunsOrderSummary = "";
  }

  hydrateKachingUpsellItemOrder(drawer);
};


/* ==========================================================================
   Header / Top Promo Bar
   ========================================================================== */

const GRUNS_CART_FREE_SHIPPING_BAR_SELECTOR =
  "[data-gruns-cart-free-shipping-bar]";

const getCartHeaderCount = (drawer) => {
  const heading = drawer.querySelector(".kaching-cart__heading");

  if (!heading) {
    return "";
  }

  const text = heading.textContent || "";
  const countMatch = text.match(/\d+/);

  return countMatch ? countMatch[0] : "";
};

const hydrateCartHeader = (drawer) => {
  const header = drawer.querySelector(".kaching-cart__header");
  const heading = drawer.querySelector(".kaching-cart__heading");

  if (!header || !heading) {
    return;
  }

  const count = getCartHeaderCount(drawer);

  heading.textContent = count ? `Your cart (${count})` : "Your cart";

  if (!drawer.querySelector(GRUNS_CART_FREE_SHIPPING_BAR_SELECTOR)) {
    const freeShippingBar = document.createElement("div");

    freeShippingBar.className = "gruns-cart-free-shipping-bar";
    freeShippingBar.dataset.grunsCartFreeShippingBar = "";

    freeShippingBar.innerHTML = `
      <span class="gruns-cart-free-shipping-bar__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none">
          <path d="M3 7h11v10H3V7Z" stroke="currentColor" stroke-width="1.8"/>
          <path d="M14 10h3.5L21 13.5V17h-7v-7Z" stroke="currentColor" stroke-width="1.8"/>
          <circle cx="7" cy="18" r="1.7" stroke="currentColor" stroke-width="1.8"/>
          <circle cx="17" cy="18" r="1.7" stroke="currentColor" stroke-width="1.8"/>
        </svg>
      </span>
      <span class="gruns-cart-free-shipping-bar__text">
        <strong>FREE SHIPPING</strong> in all orders
      </span>
    `;

    header.insertAdjacentElement("afterend", freeShippingBar);
  }
};


  const createShell = () => {
    const shell = document.createElement("div");

    shell.className = "gruns-cart-variant__shell";
    shell.dataset.grunsCartVariantShell = "";

    shell.innerHTML = `
      <div class="gruns-cart-variant__slot gruns-cart-variant__slot--header"
           data-gruns-cart-slot="header"></div>

      <div class="gruns-cart-variant__slot gruns-cart-variant__slot--items"
           data-gruns-cart-slot="items"></div>

      <div class="gruns-cart-variant__slot gruns-cart-variant__slot--upgrade"
           data-gruns-cart-slot="upgrade"></div>

      <div class="gruns-cart-variant__slot gruns-cart-variant__slot--upsell"
           data-gruns-cart-slot="upsell"></div>
    `;

    return shell;
  };

  const ensureShell = (drawer) => {
    const existingShell = drawer.querySelector(
      ":scope > [data-gruns-cart-variant-shell]"
    );

    if (existingShell) {
      return existingShell;
    }

    const shell = createShell();
    drawer.prepend(shell);

    log("Variant shell inserted.");

    return shell;
  };

  const getCartItems = (drawer) => {
    return Array.from(drawer.querySelectorAll(".kaching-cart-item"));
  };

const decodeProductHandle = (handle) => {
  if (!handle) {
    return "";
  }

  try {
    return decodeURIComponent(handle);
  } catch (error) {
    return handle;
  }
};

  const getCartItemProductHandle = (cartItem) => {
    const directHandle =
      cartItem.dataset.productHandle ||
      cartItem.getAttribute("data-product-handle") ||
      "";

    if (directHandle) {
      return decodeProductHandle(directHandle);
    }

    const productLink = cartItem.querySelector("a[href*='/products/']");
    const productUrl = productLink ? productLink.getAttribute("href") : "";

    const match = productUrl.match(/\/products\/([^/?#]+)/);

    return match ? decodeProductHandle(match[1]) : "";
  };

const isCartItemMatchingHandle = (cartItem, handle) => {
  const itemHandle = getCartItemProductHandle(cartItem);
  const normalizedHandle = decodeProductHandle(handle);

  if (itemHandle) {
    return itemHandle === normalizedHandle;
  }

  const productLink = cartItem.querySelector("a[href*='/products/']");
  const productUrl = productLink ? productLink.getAttribute("href") : "";
  const decodedProductUrl = decodeProductHandle(productUrl);

  return decodedProductUrl.includes(`/products/${normalizedHandle}`);
};

  const isCapsuleItem = (cartItem) => {
    return (
      isCartItemMatchingHandle(cartItem, GRUNS_CART_PRODUCT_HANDLES.capsule30) ||
      isCartItemMatchingHandle(cartItem, GRUNS_CART_PRODUCT_HANDLES.capsule60)
    );
  };

  const isSuperTeaItem = (cartItem) => {
    return isCartItemMatchingHandle(
      cartItem,
      GRUNS_CART_PRODUCT_HANDLES.superTea
    );
  };

  const isSticksItem = (cartItem) => {
    return isCartItemMatchingHandle(
      cartItem,
      GRUNS_CART_PRODUCT_HANDLES.sticks
    );
  };

  const isWhiskItem = (cartItem) => {
    return isCartItemMatchingHandle(
      cartItem,
      GRUNS_CART_PRODUCT_HANDLES.whisk
    );
  };

const getSelectedUpsellKey = (cartItems) => {
  if (!cartItems.length) {
    return null;
  }

  const hasPowder = cartItems.some(isSuperTeaItem);
  const hasSticks = cartItems.some(isSticksItem);

  /*
    Upsell rules:

    powder = Yerba Magic® | Instant 5-in-1 Super Tea - 30 Servings
    sticks = Yerba Magic® | Variety Pack (24 Servings)

    powder only              => sticks
    sticks only              => powder
    powder + sticks          => no upsell
    any other product        => powder
    other + powder           => sticks
    other + sticks           => powder
    other + powder + sticks  => no upsell
  */

  if (hasPowder && hasSticks) {
    return null;
  }

  if (hasPowder) {
    return "sticks";
  }

  if (hasSticks) {
    return "superTea";
  }

  return "superTea";
};

    const hydrateKachingUpsellItemOrder = (drawer) => {
    const lastUpsellHandle = sessionStorage.getItem(
      GRUNS_CART_LAST_UPSELL_HANDLE_KEY
    );

    if (!lastUpsellHandle) {
      return;
    }

    const contents = drawer.querySelector(".kaching-cart__contents");

    if (!contents) {
      return;
    }

    const upsellContainer = Array.from(
      contents.querySelectorAll(".kaching-cart-item-container")
    ).find((container) => {
      return isCartItemMatchingHandle(container, lastUpsellHandle);
    });

    if (!upsellContainer) {
      return;
    }

    const parent = upsellContainer.parentElement;

    if (!parent) {
      return;
    }

    const siblingContainers = Array.from(parent.children).filter((child) => {
      return child.classList?.contains("kaching-cart-item-container");
    });

    if (siblingContainers.length <= 1) {
      return;
    }

    const nonUpsellContainers = siblingContainers.filter((container) => {
      return container !== upsellContainer;
    });

    const lastNonUpsellContainer =
      nonUpsellContainers[nonUpsellContainers.length - 1];

    if (!lastNonUpsellContainer) {
      return;
    }

    /*
      Keep the product that was already in cart first, then the product added
      through the custom upsell. This avoids moving .kaching-cart__contents and
      only reorders sibling item containers inside Kaching's own module.
    */

    if (lastNonUpsellContainer.nextElementSibling !== upsellContainer) {
      lastNonUpsellContainer.insertAdjacentElement("afterend", upsellContainer);
    }
  };


  const getCartItemVariantIdFromHref = (container) => {
  const href =
    container.querySelector("a[href*='/products/']")?.getAttribute("href") ||
    "";

  const queryString = href.split("?")[1] || "";
  const variantId = new URLSearchParams(queryString).get("variant");

  return variantId || "";
};

const removeStaleKachingCartItems = async (drawer) => {
  if (!drawer) {
    return;
  }

  const contents = drawer.querySelector(".kaching-cart__contents");

  if (!contents) {
    return;
  }

  try {
    const response = await fetch("/cart.js", {
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      return;
    }

    const cart = await response.json();
    const validVariantIds = new Set(
      cart.items.map((item) => String(item.variant_id))
    );

    const itemContainers = Array.from(
      contents.querySelectorAll(".kaching-cart-item-container")
    );

    if (!itemContainers.length) {
      return;
    }

    const staleContainers = itemContainers.filter((container) => {
      const variantId = getCartItemVariantIdFromHref(container);

      if (!variantId) {
        return false;
      }

      return !validVariantIds.has(String(variantId));
    });

    /*
      Safety guard:
      If Shopify still has cart items, never let this cleanup remove every
      visible Kaching item container. This prevents the drawer from ending
      in a state where subtotal/footer are correct but no product rows render.
    */

    if (cart.items.length && staleContainers.length >= itemContainers.length) {
      return;
    }

    staleContainers.forEach((container) => {
      container.remove();
    });

    scheduleInitialization();
  } catch (error) {
    console.warn(
      "[Gruns Cart Variant] Unable to remove stale Kaching cart items.",
      error
    );
  }
};


const getKachingCartItemSnapshot = (drawer) => {
  if (!drawer) {
    return new Map();
  }

  const snapshot = new Map();

  Array.from(
    drawer.querySelectorAll(".kaching-cart-item-container")
  ).forEach((container) => {
    const variantId = getCartItemVariantIdFromHref(container);

    if (!variantId) {
      return;
    }

    snapshot.set(String(variantId), {
      container,
      parent: container.parentElement,
      nextSibling: container.nextElementSibling,
    });
  });

  return snapshot;
};

const restoreMissingKachingCartItems = (drawer, cart, snapshot) => {
  if (!drawer || !cart?.items?.length || !snapshot?.size) {
    return;
  }

  const contents = drawer.querySelector(".kaching-cart__contents");

  if (!contents) {
    return;
  }

  const currentVariantIds = new Set(
    Array.from(
      contents.querySelectorAll(".kaching-cart-item-container")
    )
      .map((container) => getCartItemVariantIdFromHref(container))
      .filter(Boolean)
      .map(String)
  );

  cart.items.forEach((item) => {
    const variantId = String(item.variant_id);

    if (currentVariantIds.has(variantId)) {
      return;
    }

    const savedItem = snapshot.get(variantId);

    if (!savedItem?.container) {
      return;
    }

    if (savedItem.parent?.isConnected) {
      savedItem.parent.insertBefore(
        savedItem.container,
        savedItem.nextSibling || null
      );
      return;
    }

    const existingItemModule =
      contents.querySelector(".kaching-cart__module:has(.kaching-cart-item-container)") ||
      Array.from(contents.querySelectorAll(".kaching-cart__module")).find(
        (module) => !module.textContent.trim()
      );

    if (existingItemModule) {
      existingItemModule.appendChild(savedItem.container);
      return;
    }

    const restoredModule = document.createElement("div");

    restoredModule.className = "kaching-cart__module";
    restoredModule.appendChild(savedItem.container);

    const summary = contents.querySelector(
      "[data-gruns-scrollable-order-summary]"
    );

    if (summary) {
      summary.insertAdjacentElement("beforebegin", restoredModule);
    } else {
      contents.appendChild(restoredModule);
    }
  });
};

const syncKachingCartDomWithShopifyCart = async (drawer, snapshot) => {
  if (!drawer) {
    return;
  }

  const contents = drawer.querySelector(".kaching-cart__contents");

  if (!contents) {
    return;
  }

  try {
    const response = await fetch("/cart.js", {
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      return;
    }

    const cart = await response.json();
    const validVariantIds = new Set(
      cart.items.map((item) => String(item.variant_id))
    );

    const itemContainers = Array.from(
      contents.querySelectorAll(".kaching-cart-item-container")
    );

    const staleContainers = itemContainers.filter((container) => {
      const variantId = getCartItemVariantIdFromHref(container);

      if (!variantId) {
        return false;
      }

      return !validVariantIds.has(String(variantId));
    });

    staleContainers.forEach((container) => {
      container.remove();
    });

    restoreMissingKachingCartItems(drawer, cart, snapshot);

    scheduleInitialization();
  } catch (error) {
    console.warn(
      "[Gruns Cart Variant] Unable to sync Kaching cart DOM with Shopify cart.",
      error
    );
  }
};

const installKachingCartUpdateSync = () => {
  if (window.__grunsCartUpdateSyncInstalled) {
    return;
  }

  window.__grunsCartUpdateSyncInstalled = true;

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const url = String(args[0]?.url || args[0] || "");

    const isKachingCartUpdate =
      (
        url.includes("/cart/update.js") ||
        url.includes("/cart/change.js")
      ) &&
      url.includes("kaching-cart=true");

    const drawer = getDrawer();
    const snapshot = isKachingCartUpdate
      ? getKachingCartItemSnapshot(drawer)
      : null;

    const response = await originalFetch(...args);

    if (isKachingCartUpdate && response.ok) {
      window.setTimeout(() => {
        syncKachingCartDomWithShopifyCart(drawer || getDrawer(), snapshot);
      }, 250);
    }

    return response;
  };
};

  const dispatchCartRefreshEvents = () => {
    document.dispatchEvent(
      new CustomEvent("gruns-cart-variant:item-added")
    );

    document.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
      })
    );

    window.dispatchEvent(
      new CustomEvent("cart:refresh")
    );

    window.dispatchEvent(
      new CustomEvent("cart:updated")
    );
  };

  const addUpsellToCart = async (upsell, button) => {
    if (!upsell?.variantId || !button) {
      return;
    }

    const originalText = button.textContent;

    button.disabled = true;
    button.classList.add("is-loading");
    button.textContent = "ADDING...";

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: upsell.variantId,
          quantity: 1,
        }),
      });

      if (!response.ok) {
        throw new Error(`Add to cart failed: ${response.status}`);
      }

      await response.json();

      if (upsell.productHandle) {
        sessionStorage.setItem(
          GRUNS_CART_LAST_UPSELL_HANDLE_KEY,
          upsell.productHandle
        );
      }

      button.textContent = "ADDED";




      dispatchCartRefreshEvents();

      window.setTimeout(() => {
        scheduleInitialization();
      }, CONFIG.observerDebounceMs);
    } catch (error) {
      console.error("[Gruns Cart Variant] Upsell add failed.", error);

      button.disabled = false;
      button.classList.remove("is-loading");
      button.textContent = originalText || upsell.buttonText || "ADD TO CART";
    }
  };

  const cartHasSubscriptionItems = (cartItems) => {
  return cartItems.some((cartItem) => {
    return (
      cartItem.classList.contains("gruns-cart-item--is-subscription") ||
      cartItem.dataset.hasSellingPlan === "true" ||
      Boolean(
        cartItem.querySelector(
          ".kaching-cart-item__selling-plan, .kaching-cart-item__selling-plan-name, [data-selling-plan]"
        )
      )
    );
  });
};

const getUpsellCopy = (upsell, cartItems) => {
  const copyKey = cartHasSubscriptionItems(cartItems)
    ? "subscription"
    : "oneTime";

  return (
    upsell.copy?.[copyKey] || {
      heading: upsell.heading || "",
      description: upsell.description || "",
    }
  );
};


const normalizeShopifyImageUrl = (imageUrl) => {
  if (!imageUrl) {
    return "";
  }

  if (imageUrl.startsWith("//")) {
    return `https:${imageUrl}`;
  }

  return imageUrl;
};

const getFirstProductImageFromProductJson = (product) => {
  if (product?.featured_image) {
    return normalizeShopifyImageUrl(product.featured_image);
  }

  if (Array.isArray(product?.images) && product.images.length) {
    return normalizeShopifyImageUrl(product.images[0]);
  }

  return "";
};

const requestUpsellProductImage = async (upsell) => {
  if (!upsell?.productHandle) {
    return;
  }

  if (upsell.image || upsell.imageRequested) {
    return;
  }

  const cachedImage = GRUNS_CART_PRODUCT_IMAGE_CACHE[upsell.productHandle];

  if (cachedImage) {
    upsell.image = cachedImage;
    scheduleInitialization();
    return;
  }

  upsell.imageRequested = true;

  try {
    const response = await fetch(`/products/${upsell.productHandle}.js`, {
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Product image request failed: ${response.status}`);
    }

    const product = await response.json();
    const image = getFirstProductImageFromProductJson(product);

    if (!image) {
      return;
    }

    GRUNS_CART_PRODUCT_IMAGE_CACHE[upsell.productHandle] = image;
    upsell.image = image;

    scheduleInitialization();
  } catch (error) {
    console.warn(
      "[Gruns Cart Variant] Unable to load upsell product image.",
      error
    );
  }
};


const createUpsellModule = (upsell, cartItems) => {
  const copy = getUpsellCopy(upsell, cartItems);
  const hasImage = Boolean(upsell.image);

  const module = document.createElement("div");
  module.className = "gruns-cart-upsell";
  module.dataset.grunsCartUpsell = "";
  module.dataset.grunsCartUpsellKey = upsell.key;
  module.dataset.grunsCartUpsellHasImage = hasImage ? "true" : "false";
  module.dataset.grunsCartUpsellCopy =
    cartHasSubscriptionItems(cartItems) ? "subscription" : "one-time";

  module.innerHTML = `
    <div class="gruns-cart-upsell__inner">
      <div class="gruns-cart-upsell__content">
        ${
          copy.heading
            ? `<div class="gruns-cart-upsell__heading">${copy.heading}</div>`
            : ""
        }

        ${
          copy.description
            ? `<div class="gruns-cart-upsell__description">${copy.description}</div>`
            : ""
        }

        <div class="gruns-cart-upsell__product-card">
          ${
            hasImage
              ? `
                <div class="gruns-cart-upsell__image-wrap">
                  <img
                    class="gruns-cart-upsell__image"
                    src="${upsell.image}"
                    alt="${upsell.title}"
                    loading="lazy"
                  >
                </div>
              `
              : ""
          }

          <div class="gruns-cart-upsell__product-info">
            <div class="gruns-cart-upsell__product-title">
              ${upsell.title}
            </div>

            ${
              upsell.subtitle
                ? `<div class="gruns-cart-upsell__subtitle">${upsell.subtitle}</div>`
                : ""
            }

            <div class="gruns-cart-upsell__price-wrap">
              ${
                upsell.compareAtPrice
                  ? `<span class="gruns-cart-upsell__compare-price">${upsell.compareAtPrice}</span>`
                  : ""
              }
              ${
                upsell.price
                  ? `<span class="gruns-cart-upsell__price">${upsell.price}</span>`
                  : ""
              }
            </div>
          </div>

          <button
            type="button"
            class="gruns-cart-upsell__button"
            data-gruns-cart-upsell-add
          >
            ${upsell.buttonText || "ADD TO CART"}
          </button>
        </div>
      </div>
    </div>
  `;

  const addButton = module.querySelector("[data-gruns-cart-upsell-add]");

  addButton?.addEventListener("click", () => {
    addUpsellToCart(upsell, addButton);
  });

  return module;
};

  const hydrateUpsell = (drawer) => {
    const cartItems = getCartItems(drawer);
    const selectedUpsellKey = getSelectedUpsellKey(cartItems);
    const existingUpsell = drawer.querySelector("[data-gruns-cart-upsell]");

    if (!selectedUpsellKey) {
      existingUpsell?.remove();
      drawer.classList.remove("gruns-cart-drawer--has-upsell");
      return;
    }

    const selectedUpsell = GRUNS_CART_UPSELL_PRODUCTS[selectedUpsellKey];

    if (!selectedUpsell) {
      existingUpsell?.remove();
      drawer.classList.remove("gruns-cart-drawer--has-upsell");
      return;
    }

requestUpsellProductImage(selectedUpsell);

const currentHasImage =
  existingUpsell?.dataset.grunsCartUpsellHasImage === "true";

const nextHasImage = Boolean(selectedUpsell.image);

const currentCopy = existingUpsell?.dataset.grunsCartUpsellCopy || "";
const nextCopy = cartHasSubscriptionItems(cartItems)
  ? "subscription"
  : "one-time";

if (
  existingUpsell &&
  existingUpsell.dataset.grunsCartUpsellKey === selectedUpsellKey &&
  currentHasImage === nextHasImage &&
  currentCopy === nextCopy
) {
  drawer.classList.add("gruns-cart-drawer--has-upsell");
  return;
}

  existingUpsell?.remove();

const upsellModule = createUpsellModule(selectedUpsell, cartItems);
const contents = drawer.querySelector(".kaching-cart__contents");
const footer = drawer.querySelector(".kaching-cart__footer");

if (contents) {
  contents.appendChild(upsellModule);
} else if (footer) {
  footer.insertAdjacentElement("beforebegin", upsellModule);
} else {
  drawer.appendChild(upsellModule);
}

if (drawer.querySelector("[data-gruns-cart-upsell]")) {
  drawer.classList.add("gruns-cart-drawer--has-upsell");
} else {
  drawer.classList.remove("gruns-cart-drawer--has-upsell");
}
  };

  const hydrateCartItems = (drawer) => {
    const cartItems = drawer.querySelectorAll(".kaching-cart-item");

    cartItems.forEach((cartItem) => {

      cartItem
      .querySelectorAll("[data-gruns-item-stack] .kaching-cart-item__quantity-controls")
      .forEach((el) => el.remove());

    cartItem
      .querySelectorAll("[data-gruns-item-stack] .kaching-variant-selectors-row")
      .forEach((el) => el.remove());

      const sellingPlan = cartItem.querySelector(
        ".kaching-cart-item__selling-plan, .kaching-cart-item__selling-plan-name, [data-selling-plan]"
      );

      let deliveryRow = cartItem.querySelector("[data-gruns-delivery-row]");

      if (!deliveryRow && sellingPlan) {
        deliveryRow = document.createElement("div");
        deliveryRow.className = "gruns-cart-item__delivery-row";
        deliveryRow.dataset.grunsDeliveryRow = "";

        deliveryRow.innerHTML = `
          <span>${sellingPlan.textContent.trim()}</span>
          <i></i>
        `;

        cartItem.prepend(deliveryRow);
      }

      const contentLeft = cartItem.querySelector(".kaching-cart-item__content-left");

      const total = Array.from(
        cartItem.querySelectorAll(".kaching-cart-item__total")
      ).find((el) => !el.closest("[data-gruns-item-stack]"));
      const bundleBadge = cartItem.querySelector(".kaching-cart__badge--bundle");
      const savingsBadge = cartItem.querySelector(".kaching-cart__badge--savings");

      const flavorLabel = Array.from(cartItem.querySelectorAll("*")).find((el) =>
        el.textContent?.trim() === "Flavor:"
      );

      let customStack = cartItem.querySelector("[data-gruns-item-stack]");

      if (contentLeft && !customStack) {
        customStack = document.createElement("div");
        customStack.className = "gruns-cart-item__stack";
        customStack.dataset.grunsItemStack = "";
        contentLeft.appendChild(customStack);
      }

      if (customStack) {
        if (total) {
          customStack
            .querySelectorAll(".kaching-cart-item__total")
            .forEach((el) => el.remove());

          customStack.prepend(total);
        }

        if (bundleBadge && bundleBadge.parentElement !== customStack) {
          customStack.appendChild(bundleBadge);
        }

        if (savingsBadge && savingsBadge.parentElement !== customStack) {
          customStack.appendChild(savingsBadge);
        }
      }

      const hasUpgradeButton = Boolean(
        cartItem.querySelector(".kaching-cart-item__selling-plan-upgrade")
      );

      const hasVariantSelectors = Boolean(
        cartItem.querySelector(".kaching-variant-selectors-row")
      );

      const hasBundleBadge = Boolean(
        cartItem.querySelector(".kaching-cart__badge--bundle")
      );

      const hasBundleQuantity = Boolean(
        cartItem.querySelector(".kaching-cart-item__bundle-quantity")
      );

      const hasOldPrice = Boolean(
        cartItem.querySelector(".kaching-cart-item__total-old")
      );

      const hasSellingPlan =
        cartItem.dataset.hasSellingPlan === "true" ||
        Boolean(
          cartItem.querySelector(
            ".kaching-cart-item__selling-plan, .kaching-cart-item__selling-plan-name, [data-selling-plan]"
          )
        );

      cartItem.classList.toggle(
        "gruns-cart-item--has-upgrade",
        hasUpgradeButton
      );

      cartItem.classList.toggle(
        "gruns-cart-item--has-variant-selectors",
        hasVariantSelectors
      );

      cartItem.classList.toggle(
        "gruns-cart-item--has-bundle",
        hasBundleBadge || hasBundleQuantity
      );

      cartItem.classList.toggle(
        "gruns-cart-item--has-savings",
        hasOldPrice
      );

      cartItem.classList.toggle(
        "gruns-cart-item--is-subscription",
        hasSellingPlan
      );

      cartItem.classList.toggle(
        "gruns-cart-item--is-simple",
        !hasUpgradeButton &&
          !hasVariantSelectors &&
          !hasBundleBadge &&
          !hasBundleQuantity &&
          !hasSellingPlan
      );
    });
  };

  const hydrateDrawerState = (drawer) => {
    const items = [...drawer.querySelectorAll(".kaching-cart-item")];

    const hasSubscriptionItems = items.some((item) =>
      item.classList.contains("gruns-cart-item--is-subscription")
    );

    const hasUpgradeableItems = items.some((item) =>
      item.classList.contains("gruns-cart-item--has-upgrade")
    );

    const hasSimpleItems = items.some((item) =>
      item.classList.contains("gruns-cart-item--is-simple")
    );

    const hasBundleItems = items.some((item) =>
      item.classList.contains("gruns-cart-item--has-bundle")
    );

    drawer.classList.toggle(
      "gruns-cart-drawer--has-subscription-items",
      hasSubscriptionItems
    );

    drawer.classList.toggle(
      "gruns-cart-drawer--has-upgrade-items",
      hasUpgradeableItems
    );

    drawer.classList.toggle(
      "gruns-cart-drawer--has-simple-items",
      hasSimpleItems
    );

    drawer.classList.toggle(
      "gruns-cart-drawer--has-bundle-items",
      hasBundleItems
    );
  };

  const hydrateUpgradeModules = (drawer) => {
    const cartItems = drawer.querySelectorAll(".kaching-cart-item");

    cartItems.forEach((cartItem) => {
      const nativeUpgradeButton = cartItem.querySelector(
        ".kaching-cart-item__selling-plan-upgrade"
      );

      const existingModule = cartItem.querySelector(
        "[data-gruns-upgrade-module]"
      );

      if (!nativeUpgradeButton) {
        existingModule?.remove();
        return;
      }

      if (existingModule) {
        return;
      }

      const upgradeModule = document.createElement("div");
      upgradeModule.className = "gruns-upgrade-module";
      upgradeModule.dataset.grunsUpgradeModule = "";

      upgradeModule.innerHTML = `
        <div class="gruns-upgrade-module__badge">
          MOST POPULAR
        </div>

        <div class="gruns-upgrade-module__title">
          Subscribe & Save An Extra 25%
        </div>

        <ul class="gruns-upgrade-module__benefits">
          <li>30-day guarantee</li>
          <li>Free US shipping</li>
          <li>Pause or cancel anytime</li>
        </ul>

        <button
          type="button"
          class="gruns-upgrade-module__button"
          data-gruns-upgrade-trigger
        >
          UPGRADE AND SAVE ↑
        </button>
      `;

      const trigger = upgradeModule.querySelector(
        "[data-gruns-upgrade-trigger]"
      );

      trigger.addEventListener("click", () => {
        nativeUpgradeButton.click();
      });

      cartItem.appendChild(upgradeModule);
    });
  };

  const hydrateFooterBenefits = (drawer) => {
    const footer = drawer.querySelector(".kaching-cart__footer");

    if (!footer) {
      return;
    }

    const existingBenefits = footer.querySelector(
      "[data-gruns-footer-benefits]"
    );

    if (existingBenefits) {
      return;
    }

    const checkoutButton = footer.querySelector(
      "#kaching-cart__checkout-button"
    );

    if (!checkoutButton) {
      return;
    }

    const benefits = document.createElement("div");
    benefits.className = "gruns-cart-footer-benefits";
    benefits.dataset.grunsFooterBenefits = "";

    benefits.innerHTML = `
      <div class="gruns-cart-footer-benefits__item">
        <span class="gruns-cart-footer-benefits__icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M12 3.5l2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 17.4l-5.4 2.9 1-6.1L3.2 9.9l6.1-.9L12 3.5z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round"/>
          </svg>
        </span>
        <span>4.8 stars, 5k+ Reviews</span>
      </div>

      <div class="gruns-cart-footer-benefits__item">
        <span class="gruns-cart-footer-benefits__icon">
          <svg viewBox="0 0 24 24" fill="none">
            <rect x="3" y="5" width="18" height="16" rx="2"
              stroke="currentColor" stroke-width="2"/>
            <path d="M8 3V7M16 3V7M3 10H21"
              stroke="currentColor" stroke-width="2"
              stroke-linecap="round"/>
          </svg>
        </span>
        <span>Pause or cancel anytime</span>
      </div>

      <div class="gruns-cart-footer-benefits__item">
        <span class="gruns-cart-footer-benefits__icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M7 7h8a5 5 0 1 1 0 10h-1"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"/>
            <path d="M7 7l3-3M7 7l3 3"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"/>
          </svg>
        </span>
        <span>30-Day easy returns</span>
      </div>
    `;

    checkoutButton.insertAdjacentElement("afterend", benefits);
  };

  

const setTextIfChanged = (element, nextText) => {
  if (!element) return;

  const normalizedNextText = String(nextText || "").trim();

  if (element.textContent.trim() === normalizedNextText) {
    return;
  }

  element.textContent = normalizedNextText;
};

const setHTMLIfChanged = (element, nextHTML) => {
  if (!element) return;

  const normalizedNextHTML = String(nextHTML || "").trim();

  if (element.innerHTML.trim() === normalizedNextHTML) {
    return;
  }

  element.innerHTML = normalizedNextHTML;
};

const getDiscountsSignature = (drawer) => {
  return Array.from(drawer.querySelectorAll(".kaching-cart__cart-discounts"))
    .filter((discount) => !discount.closest("[data-gruns-scrollable-order-summary]"))
    .map((discount) => discount.textContent.trim().replace(/\s+/g, " "))
    .join("|");
};



const hydrateOrderSummary = (drawer) => {
  const footer = drawer.querySelector(".kaching-cart__footer");

  if (!footer) {
    return;
  }

  footer.dataset.grunsOrderSummary = "";

  const summary = getScrollableOrderSummary(drawer);

  if (!summary.querySelector("[data-gruns-order-summary-title]")) {
    const title = document.createElement("h3");
    title.className = "gruns-order-summary__title";
    title.dataset.grunsOrderSummaryTitle = "";
    title.textContent = "Order Summary";

    summary.appendChild(title);
  }

  let summarySubtotalRow = summary.querySelector("[data-gruns-summary-subtotal-row]");

  if (!summarySubtotalRow) {
    summarySubtotalRow = document.createElement("div");
    summarySubtotalRow.className =
      "gruns-order-summary__row gruns-order-summary__row--subtotal";
    summarySubtotalRow.dataset.grunsSummarySubtotalRow = "";

    summarySubtotalRow.innerHTML = `
      <span class="gruns-order-summary__row-label">Subtotal</span>
      <span class="gruns-order-summary__row-value" data-gruns-summary-subtotal-value></span>
    `;

    summary.querySelector("[data-gruns-order-summary-title]")
      .insertAdjacentElement("afterend", summarySubtotalRow);
  }

  // summary
  //   .querySelectorAll("[data-gruns-discount-row]")
  //   .forEach((row) => row.remove());

  // const sourceDiscountsSnapshot = Array.from(
  //   drawer.querySelectorAll(".kaching-cart__cart-discounts")
  // )
  //   .filter((discount) => !discount.closest("[data-gruns-scrollable-order-summary]"))
  //   .map((discount) => discount.cloneNode(true));

  // sourceDiscountsSnapshot.forEach((discountClone) => {
  //   discountClone.dataset.grunsDiscountRow = "";
  //   summarySubtotalRow.insertAdjacentElement("afterend", discountClone);
  // });


  const nextDiscountsSignature = getDiscountsSignature(drawer);
const currentDiscountsSignature = summary.dataset.grunsDiscountsSignature || "";

if (nextDiscountsSignature !== currentDiscountsSignature) {
  summary
    .querySelectorAll("[data-gruns-discount-row]")
    .forEach((row) => row.remove());

  const sourceDiscountsSnapshot = Array.from(
    drawer.querySelectorAll(".kaching-cart__cart-discounts")
  )
    .filter((discount) => !discount.closest("[data-gruns-scrollable-order-summary]"))
    .map((discount) => discount.cloneNode(true));

  [...sourceDiscountsSnapshot].reverse().forEach((discountClone) => {
    discountClone.dataset.grunsDiscountRow = "";
    summarySubtotalRow.insertAdjacentElement("afterend", discountClone);
  });

  summary.dataset.grunsDiscountsSignature = nextDiscountsSignature;
}

  const footerSubtotal = footer.querySelector(".kaching-cart__subtotal");

  const footerSubtotalValue = footerSubtotal
    ? Array.from(footerSubtotal.querySelectorAll(":scope > span")).find(
        (el) => !el.matches("[data-gruns-footer-savings]")
      )
    : null;
  const summarySubtotalValue = summary.querySelector("[data-gruns-summary-subtotal-value]");

  // if (footerSubtotalValue && summarySubtotalValue) {
  //   summarySubtotalValue.textContent = footerSubtotalValue.textContent.trim();
  // }

  if (footerSubtotalValue && summarySubtotalValue) {
  setTextIfChanged(summarySubtotalValue, footerSubtotalValue.textContent);
}

  const parseMoney = (text) => {
    const clean = (text || "").replace(/[^0-9.]/g, "");
    return clean ? parseFloat(clean) : 0;
  };

  const formatMoney = (value) => {
    return `$${value.toFixed(2)}`;
  };

  const footerDiscountAmounts = Array.from(
    footer.querySelectorAll(
      ".kaching-cart__cart-discounts-amount:not([data-gruns-generated])"
    )
  ).filter((el) => !el.closest("[data-gruns-scrollable-order-summary]"));

  const totalDiscount = footerDiscountAmounts.reduce((sum, el) => {
    return sum + Math.abs(parseMoney(el.textContent));
  }, 0);

  const finalSubtotal = parseMoney(
    footerSubtotalValue ? footerSubtotalValue.textContent : ""
  );

  const originalSubtotal = finalSubtotal + totalDiscount;

  let savingsWrap = footer.querySelector("[data-gruns-footer-savings]");

  if (!savingsWrap) {
    savingsWrap = document.createElement("span");
    savingsWrap.className = "gruns-footer-savings";
    savingsWrap.dataset.grunsFooterSavings = "";

    footerSubtotalValue?.insertAdjacentElement("beforebegin", savingsWrap);
  }

  if (totalDiscount > 0 && originalSubtotal > finalSubtotal) {
    const savingsPercent = Math.round((totalDiscount / originalSubtotal) * 1000) / 10;

    // savingsWrap.innerHTML = `
    //   <span class="gruns-footer-savings__badge" data-gruns-generated>${savingsPercent}% OFF</span>
    //   <span class="gruns-footer-savings__old-price" data-gruns-generated>${formatMoney(originalSubtotal)}</span>
    // `;


    setHTMLIfChanged(
  savingsWrap,
  `
    <span class="gruns-footer-savings__badge" data-gruns-generated>${savingsPercent}% OFF</span>
    <span class="gruns-footer-savings__old-price" data-gruns-generated>${formatMoney(originalSubtotal)}</span>
  `
);

    savingsWrap.style.display = "";
  } else if (savingsWrap) {
    savingsWrap.style.display = "none";
  }

  if (!summary.querySelector("[data-gruns-shipping-row]")) {
    const shippingRow = document.createElement("div");
    shippingRow.className =
      "gruns-order-summary__row gruns-order-summary__row--shipping";
    shippingRow.dataset.grunsShippingRow = "";

    shippingRow.innerHTML = `
      <span class="gruns-order-summary__row-label">
        <span class="gruns-order-summary__row-icon"><svg viewBox="0 0 22 22" width="28" height="28" fill="none">
          <path d="M3 7h11v10H3V7Z" stroke="currentColor" stroke-width="1.8"/>
          <path d="M14 10h3.5L21 13.5V17h-7v-7Z" stroke="currentColor" stroke-width="1.8"/>
          <circle cx="7" cy="18" r="1.7" stroke="currentColor" stroke-width="1.8"/>
          <circle cx="17" cy="18" r="1.7" stroke="currentColor" stroke-width="1.8"/>
        </svg></span>
        Shipping
      </span>
      <span class="gruns-order-summary__row-value">FREE SHIPPING</span>
    `;

    summary.appendChild(shippingRow);
  }

  if (!summary.querySelector("[data-gruns-taxes-row]")) {
    const taxesRow = document.createElement("div");
    taxesRow.className =
      "gruns-order-summary__row gruns-order-summary__row--taxes";
    taxesRow.dataset.grunsTaxesRow = "";

    taxesRow.innerHTML = `
      <span class="gruns-order-summary__row-label">
        <span class="gruns-order-summary__row-icon">$</span>
        Taxes
      </span>
      <span class="gruns-order-summary__row-value">Calculated at checkout</span>
    `;

    summary.appendChild(taxesRow);
  }

  const checkoutLabel = footer.querySelector(
    "#kaching-cart__checkout-button .kaching-cart__checkout-button-label"
  );

  // if (checkoutLabel) {
  //   const currentText = checkoutLabel.textContent.trim();
  //   const amountMatch = currentText.match(/\$[\d,.]+/);
  //   const amount = amountMatch ? amountMatch[0] : "";

  //   checkoutLabel.innerHTML = `
  //     SECURE CHECKOUT
  //     <span class="gruns-checkout-lock-icon">
  //       <svg viewBox="0 0 24 24" fill="none">
  //         <path d="M7 10V7a5 5 0 0 1 10 0v3" stroke="currentColor" stroke-width="2"/>
  //         <rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" stroke-width="2"/>
  //       </svg>
  //     </span>
  //   `;

  //   const checkoutButton = footer.querySelector(
  //     "#kaching-cart__checkout-button"
  //   );

  //   if (checkoutButton && amount) {
  //     checkoutButton.dataset.grunsCheckoutAmount = amount;
  //   }
  // }

  if (checkoutLabel) {
  const currentText = checkoutLabel.textContent.trim();
  const amountMatch = currentText.match(/\$[\d,.]+/);
  const amount = amountMatch ? amountMatch[0] : "";

  const checkoutButton = footer.querySelector(
    "#kaching-cart__checkout-button"
  );

  if (checkoutButton && amount) {
    checkoutButton.dataset.grunsCheckoutAmount = amount;
  }

  if (checkoutLabel.dataset.grunsCheckoutLabelHydrated !== "true") {
    checkoutLabel.dataset.grunsCheckoutLabelHydrated = "true";

    checkoutLabel.innerHTML = `
      SECURE CHECKOUT
      <span class="gruns-checkout-lock-icon">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M7 10V7a5 5 0 0 1 10 0v3" stroke="currentColor" stroke-width="2"/>
          <rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" stroke-width="2"/>
        </svg>
      </span>
    `;
  }
}

const contents = drawer.querySelector(".kaching-cart__contents");

if (
  contents &&
  summary.children.length &&
  summary.parentElement !== contents
) {
  contents.appendChild(summary);
}
};

  const initializeDrawer = () => {
    if (!isVariantAllowed()) {
      return;
    }

    const drawer = getDrawer();

    if (!drawer) {
      log("Drawer not available yet.");
      return;
    }


    installKachingCartUpdateSync();

    document.documentElement.classList.add(CONFIG.activeClass);

    drawer.classList.add(CONFIG.drawerActiveClass);
    drawer.dataset.grunsCartVariantInitialized = "true";

    hydrateCartHeader(drawer);
    ensureShell(drawer);
    hydrateCartItems(drawer);
    hydrateDrawerState(drawer);
    hydrateUpgradeModules(drawer);
    hydrateUpsell(drawer);
    hydrateOrderSummary(drawer);
    hydrateFooterBenefits(drawer);
    hydrateScrollableCartLayout(drawer);

    log("Drawer initialized.");
  };

  const scheduleInitialization = () => {
    window.clearTimeout(debounceTimer);

    debounceTimer = window.setTimeout(() => {
      initializeDrawer();
    }, CONFIG.observerDebounceMs);
  };

  // const startObserver = () => {
  //   observer = new MutationObserver(() => {
  //     scheduleInitialization();
  //   });

  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true,
  //   });

  //   log("MutationObserver started.");
  // };


  const shouldIgnoreMutation = (mutation) => {
  const target = mutation.target;

  if (!(target instanceof Element)) {
    return false;
  }

  return Boolean(
    target.closest("[data-gruns-scrollable-order-summary]") ||
    target.closest("[data-gruns-cart-upsell]") ||
    target.closest("[data-gruns-footer-benefits]") ||
    target.closest("[data-gruns-upgrade-module]") ||
    target.closest("[data-gruns-cart-free-shipping-bar]") ||
    target.closest("[data-gruns-cart-variant-shell]")
  );
};

const startObserver = () => {
  observer = new MutationObserver((mutations) => {
    const relevantMutations = mutations.filter(
      (mutation) => !shouldIgnoreMutation(mutation)
    );

    if (!relevantMutations.length) {
      return;
    }

    scheduleInitialization();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  log("MutationObserver started.");
};

  const destroy = () => {
    window.clearTimeout(debounceTimer);

    if (observer) {
      observer.disconnect();
    }

    document.documentElement.classList.remove(CONFIG.activeClass);

    document
      .querySelectorAll("[data-gruns-cart-variant-shell]")
      .forEach((element) => element.remove());

    document
      .querySelectorAll("[data-gruns-cart-variant-initialized]")
      .forEach((element) => {
        element.classList.remove(CONFIG.drawerActiveClass);
        delete element.dataset.grunsCartVariantInitialized;
      });

    document
      .querySelectorAll("[data-gruns-cart-upsell]")
      .forEach((element) => element.remove());

    document
      .querySelectorAll("[data-gruns-footer-benefits]")
      .forEach((element) => element.remove());

    document
      .querySelectorAll("[data-gruns-upgrade-module]")
      .forEach((element) => element.remove());

      document
  .querySelectorAll("[data-gruns-cart-free-shipping-bar]")
  .forEach((element) => element.remove());

    document
      .querySelectorAll("[data-gruns-cart-scroll-area]")
      .forEach((element) => element.remove());

    document
      .querySelectorAll("[data-gruns-scrollable-order-summary]")
      .forEach((element) => element.remove());

    log("Variant destroyed.");
  };

  if (!isVariantAllowed()) {
    log("Skipped: variant not allowed.");
    return;
  }

  initializeDrawer();
  startObserver();

  window[INSTANCE_KEY] = {
    destroy,
    initializeDrawer,
  };
})();